import React from 'react';
import { useConnect } from '@lore/query-connect';
import useStewardshipFilter from '../../partners/useStewardshipFilter';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../ComparisonMetric';
import { project_networkId, tags_partner } from '../../../utils/query-helpers';

export default function InvitedToProject(props) {
  const { state, network, schoolStart, schoolEnd, titleOnly } = props;

  const stewardshipFilter = useStewardshipFilter();

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfQuestions',
            relation: 'questions',
            $where: {
              projectId: {
                $null: false
              },
              // ...project_networkId(network),
              project: {
                $where: {
                  site: {
                    $where: {
                      state: {
                        $ilike: state
                      }
                    }
                  }
                }
              },
              createdAt: {
                $lte: schoolStart,
                $gte: titleOnly ? undefined : previousSchoolStart
              }
            }
          }
        ],
        $where: {
          ...tags_partner(),
          state: {
            $ilike: state
          },
          // $or: stewardshipFilter
        },
        $having: {
          numberOfQuestions: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  const newUsers = useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfQuestions',
            relation: 'questions',
            $where: {
              projectId: {
                $null: false
              },
              // ...project_networkId(network),
              project: {
                $where: {
                  site: {
                    $where: {
                      state: {
                        $ilike: state
                      }
                    }
                  }
                }
              },
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              }
            }
          }
        ],
        $where: {
          ...tags_partner(),
          state: {
            $ilike: state
          },
          // $or: stewardshipFilter
        },
        $having: {
          numberOfQuestions: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    previousUsers.state === PayloadStates.FETCHING ||
    newUsers.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Invited to Project"
      />
    );
  }

  return (
    <ComparisonMetric
      name="Invited to Project"
      value={newUsers.meta.totalCount}
      previousValue={previousUsers.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
